export const normalizeErrorForLogging = (error: Error | unknown): Error => {
  let message: string;
  let stack: string;
  let name: string;

  if (typeof error === 'string') {
    message = error;
    stack = 'Unknown Error';
    name = 'Error';
  } else {
    const isObject = error !== null && typeof error === 'object';
    message = isObject && 'message' in error ? String((error as { message?: unknown; }).message) : 'Unknown Error';
    const rawStack = isObject && 'stack' in error ? (error as { stack?: unknown; }).stack : undefined;
    stack =
      typeof rawStack === 'string'
        ? rawStack
        : rawStack !== undefined
          ? String(rawStack)
          : 'Unknown Error';
    const rawName = isObject && 'name' in error ? (error as { name?: unknown; }).name : undefined;
    name = typeof rawName === 'string' && rawName !== 'Error' ? rawName : 'Error';
  }

  const prefixed = new Error(`APPLICATION_EXCEPTION: ${message}`);
  prefixed.stack = stack;
  prefixed.name = name;
  return prefixed;
};
